import React, { Fragment, useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Button,
  Input,
  Table
} from "reactstrap";
import { Breadcrumbs } from "../../../../AbstractElements";
import { productData } from "../ProductManagement/PageComponents/index";
import { Grid2X2, LayoutGrid, List, RefreshCw } from "lucide-react";
import ProductTable from "../ProductManagement/PageComponents/ProductTable";
import ProductFormModal from "../ProductManagement/PageComponents/ProductFormModal";
import "./PageComponents/Product.scss";
import { Plus } from "react-feather";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode"
import { deleteProduct, updateProduct, updateStatus } from "../../../../api-handle/productApi";
import DeleteConfirmationModal from "./PageComponents/DeleteProductModal";
import { Category } from './../../../../Constant/index';

const ProductManagement = () => {
  const [viewType, setViewType] = useState("table");
  const [filterStock, setFilterStock] = useState("all");
  const [filterStatus, setFilterStatus] = useState("all");
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showTable, setShowTable] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");


  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleDeleteClick = (product) => {
    setSelectedProduct(product);
    setIsModalOpen(true);
  };

  const handleDeActivate = async (product) => {
    try {
      await updateStatus(product._id,)
      setRefresh(!refresh)
    } catch (error) {
      console.error(error)
    }
  }


  const token = localStorage.getItem("access_token")

  const merchant = jwtDecode(token);

  //"Merchant : ", merchant)

  const toggleView = () => {
    setViewType(viewType === "table" ? "cards" : "table");
  };

  const openModal = (product = null) => {
    setSelectedProduct(product);
    setModalOpen(true);
  };

  const handleDelete = (product) => {
    //`Deleting Product ID: ${product._id}`);
  };

  const [refresh, setRefresh] = useState(false)

  const confirmDelete = async () => {
    try {
      await deleteProduct(selectedProduct._id);
      alert("Product deleted successfully!");
    } catch (error) {
      alert("Failed to delete product.");
      console.error(error);
    } finally {
      setIsModalOpen(false);
      setRefresh(!refresh)
    }
  };

  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  return (
    <Fragment>
      <Breadcrumbs
        mainTitle="Product Management"
        parent="Seller Panel"
        title="Manage Products"
      />
      <Container fluid={true}>
        <Row>
          <Col xl="12">
            <Card>
              <CardHeader className="header-container" style={{ paddingBottom: "1rem" }}>
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "1rem",
                    alignItems: "center",
                  }}
                >
                  {/* Category / Sub-Category / Brand list-filters removed:
                      products inherit a single category/sub-category from the
                      merchant's marketplace account settings (the product modal
                      no longer selects them), so per-category list-filtering is
                      inert. Filter by search instead. */}

                  {/* Search Input */}
                  <input
                    type="text"
                    placeholder="Search..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    className="form-control"
                    style={{ flex: "1 1 200px" }}
                  />

                  {/* Add Product Button */}
                  <button
                    onClick={() => openModal()}
                    style={{
                      flex: "1 1 150px",
                      backgroundColor: "#33bdbf",
                      color: "#fff",
                      border: "none",
                      padding: "10px 16px",
                      borderRadius: "6px",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "6px"
                    }}
                  >
                    <Plus size={18} /> Add Product
                  </button>

                  {/* Reset Filters Button */}
                  <button
                    onClick={() => {
                      setSearchQuery("");
                    }}
                    style={{
                      flex: "1 1 150px",
                      backgroundColor: "#f73164",
                      color: "#fff",
                      border: "none",
                      padding: "10px 16px",
                      borderRadius: "6px",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "6px"
                    }}
                  >
                    <RefreshCw size={18} /> Reset Filters
                  </button>


                  {/* Toggle View */}
                  <div style={{ marginLeft: "auto" }}>
                    <div
                      onClick={() => setShowTable(!showTable)}
                      style={{
                        background: "#33bdbf",
                        color: "white",
                        padding: "10px",
                        borderRadius: "4px",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      {showTable ? <List size={18} /> : <Grid2X2 size={18} />}
                    </div>
                  </div>
                </div>
              </CardHeader>
              <CardBody>
                <ProductTable
                  onEdit={openModal}
                  onDelete={handleDeleteClick}
                  onDeactivate={handleDeActivate}
                  refresh={refresh}
                  showTable={showTable}
                  searchQuery={searchQuery}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>

      {/* Add/Edit Product Modal */}
      <ProductFormModal
        isOpen={modalOpen}
        toggle={() => setModalOpen(false)}
        productData={selectedProduct}
        merchantId={merchant._id}
        onRefresh={() => {
          setRefresh(!refresh)
        }}
      />
      <DeleteConfirmationModal
        isOpen={isModalOpen}
        toggle={() => setIsModalOpen(false)}
        onConfirm={confirmDelete}
      />
    </Fragment>
  );
};

export default ProductManagement;
